<template>
 <div> <!-- Only one element for Transition -->
  <template v-if="hasTransports">
    <div class="row" v-if="!participation?.travel.packageMandatory">
      <div class="btn-group" role="group" aria-label="Basic radio toggle button group" :class="{'is-invalid': packageSelectionErrorMessage}">
        <input type="radio" class="btn-check" v-model="packageSelectionValue" :value="true" name="packageSelection" id="packageSelection-true" autocomplete="off">
        <label class="btn btn-outline-primary" for="packageSelection-true">{{participation?.travel.buttonPackageSelectionLabel??'Je viens aux dates du Package'}}<br/><small>( {{ formatDatePeriod(participation?.travel.startDate, participation?.travel.endDate,false) }} )</small></label>

        <input type="radio" class="btn-check" v-model="packageSelectionValue" :value="false" name="packageSelection" id="packageSelection-false" autocomplete="off">
        <label class="btn btn-outline-primary d-flex justify-content-center" for="packageSelection-false">
          <div class="align-self-center">Je sélectionne mes dates</div>
        </label>
      </div>
    </div>
    <div v-if="packageSelectionValue">
      <h5 class="mt-3">
        <span v-if="(((participation?.travel.transportations?.length??0) == 1) && ((participation?.travel.transportations![0]?.options?.length??0) <= 1))">Information Transport</span>
        <span v-else>Choix du Transport</span>
      </h5>
      <div class="small text-muted"><em>( Horaires sous réserve de modifications de la compagnie aérienne / Transferts hôtels inclus )</em></div>
      <div v-for="transport in participation?.travel.transportations" :key="transport.id">
      <div
        class="card mt-3"
        role="button"
        :class="{
          'border-2 border-primary bg-primary bg-opacity-25': transportValue == transport.id,
          'bg-light' : withoutTransportSelectionValue,
          'border-danger': transportErrorMessage
        }"
        >
        <label role="button">
          <input type="radio" name="transportSelection" v-model="transportValue" :value="transport.id" @change="transportOptionValue = null" hidden />
          <div class="card-body d-flex flex-column flex-md-row p-2">
            <div class="me-4">
              <i :class="{ 'fa fa-plane': transport.type === 'Vol', 'fa fa-train': transport.type === 'Train', 'fa fa-bus': transport.type === 'Autocar' }" class="text-primary"></i>
            </div>
            <div>
              <div>Aller - <b v-html="formatNameToHtml(transport.outboundItinerary)"></b></div>
              <div><em>{{ transport.outboundDate }}</em></div>
              <div><small>{{ transport.outboundCompany }}</small></div>
            </div>
            <div class="mx-4"><i class="fa fa-arrow-right"></i></div>
            <div>
              <div>Retour - <b v-html="formatNameToHtml(transport.returnItinerary)"></b></div>
              <div><em>{{ transport.returnDate }}</em></div>
              <div><small>{{ transport.returnCompany }}</small></div>
            </div>
            <div class="ms-auto text-end" v-if="transport.quota > 0">
              <div v-if="transport.quotaLeft > 0" class="small">
                Sièges restants <span class="border rounded p-1 px-3 ms-1" :class="{'text-danger': transport.quotaLeft <= 5}">{{ transport.quotaLeft }}</span>
              </div>
              <div v-else class="small text-danger pe-2">Epuisé</div>
            </div>
          </div>
        </label>
      </div>
      <div class="card mt-1 border-primary" v-if="transportValue == transport.id && transport.options && transport.options.length > 0 && !withoutTransportSelectionValue">
        <div class="card-header py-1 bg-primary bg-opacity-25">
          <small>Choix Catégorie Siège</small>
        </div>
        <ul class="list-group list-group-flush">
          <label
            role="button"
            class="list-group-item"
            v-for="option in sortedOptions(transport)"
            :key="option.id"
            :class="{'bg-primary bg-opacity-25': transportOptionValue == option.id, 'border-danger': transportOptionErrorMessage, 'disabled': !canBeSelected(option) }"
          >
            <input type="radio"
              name="transportSelection"
              v-model="transportOptionValue"
              :value="option.id"
              hidden
              :disabled="!canBeSelected(option)" />
            <div class="d-flex flex-column flex-md-row">
              <div class="fw-bold align-self-md-center" v-html="formatNameToHtml(option.name)"></div>
              <div class="ms-auto text-end d-flex flex-column">
                <div>
                  <span v-if="option.price == 0" class="badge bg-success">Inclus</span>
                  <span v-else class="badge bg-primary">{{ formatPrice(option.price) }} € / siège.</span>
                </div>
                <div class="small pt-1">
                  <span v-if="option.quota == 0">&nbsp;</span>
                  <span v-else-if="option.quotaLeft > 0" :class="[ option.quotaLeft <= 5 ? 'text-danger' : '' ]">{{option.quotaLeft}} sièges restants</span>
                  <span v-else><span class="text-danger">Épuisé</span> <em>/ Contacter l'organisation</em></span>
                </div>
              </div>
            </div>
          </label>
        </ul>
      </div>
      </div>

      <!-- <div
        v-if="!participation?.travel.packageMandatory"
        class="card mt-3"
        role="button"
        :class="{
         'border-2 border-primary bg-primary bg-opacity-25': specialCaseSelectionValue,
         'bg-light' : withoutTransportSelectionValue,
         'border-danger': transportErrorMessage
         }">
        <label role="button">
          <input type="radio" name="transportSelection" v-model="specialCaseSelectionValue" :value="true" hidden />
          <div class="card-body d-flex flex-column p-2">
            <div>
              Cas Particulier
              <div class="small"><em>Extension Séjour avant ou après</em></div>
            </div>
            <TransportationCustomComponent v-if="specialCaseSelectionValue" v-model="participation" class="mt-3" />
          </div>
        </label>
      </div> -->
      <div
        class="card mt-3"
        v-if="!participation?.travel.packageMandatory"
        role="button"
        :class="{
         'border-2 border-primary bg-primary bg-opacity-25': withoutTransportSelectionValue,
        //  'bg-light' : !withoutTransportSelectionValue,
         'border-danger': transportErrorMessage
        }">
        <label role="button">
          <input type="radio" name="transportSelection" v-model="withoutTransportSelectionValue" :value="true" hidden />
          <div class="card-body d-flex p-2">
            <div>
              Sans Vol ( <b>-{{(participation?.travel?.transportCost??0)}} €</b> )
              <div class="small"><em>Vols et transferts à votre charge</em></div>
              <TransportationCustomComponent v-if="withoutTransportSelectionValue" :lock-dates="true" v-model="participation" class="mt-3" />
            </div>
          </div>
        </label>
      </div>
    </div>
    <template v-if="!packageSelectionValue">
      <div class="card mt-3">
        <!-- <div class="card-header">
          <h5 class="mb-0">J'indique mes dates</h5>
        </div> -->
        <div class="card-body d-flex justify-content-around flex-column flex-md-row">
          <DatePickerComponent
            value-key="travelInfo.customStartDate"
            label="Arrivée"
            placeholder="Arrivée"
            :required="true"
            class="mb-3 col-12 col-md-5"
            :min-date="participation?.travel?.startDate ? dayjs(participation.travel.startDate).add(-15, 'days').toDate() : null"
            :max-date="participation?.travel?.endDate ? dayjs(participation.travel.endDate).add(15, 'days').toDate() : null"
            @change="() => { if (participation?.travelInfo?.customStartDate != null) { setOutboundDate(participation?.travelInfo?.customStartDate) } }"
          />
          <DatePickerComponent
            value-key="travelInfo.customEndDate"
            label="Départ"
            placeholder="Départ"
            :required="true"
            class="mb-3 col-12 col-md-5"
            :min-date="participation?.travelInfo?.customStartDate ?? new Date()"
            :max-date="participation?.travel?.endDate ? dayjs(participation.travel.endDate).add(15, 'days').toDate() : null"
            @change="() => { if (participation?.travelInfo?.customEndDate != null) { setReturnDate(participation?.travelInfo?.customEndDate) } }"
          />
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">
          <h5 class="mb-0">Détails de mes Vols</h5>
        </div>
        <div class="card-body">
          <TransportationCustomComponent v-model="participation" :lock-dates="false" />
        </div>
      </div>
    </template>
  </template>
  <PageBottomMessage message-key="pageTransports"></PageBottomMessage>
</div>
</template>

<script lang="ts" setup>
  import dayjs from 'dayjs';
  import { watch, computed } from 'vue';
  import { useField } from 'vee-validate';
  import { formatDatePeriod, formatNameToHtml, formatPrice } from '@/compositions/helper';
  import { useUserStore } from '@/stores/userStore';

  const participation = defineModel<UserParticipation>();
  const userStore = useUserStore();

  const { value: packageSelectionValue, errorMessage: packageSelectionErrorMessage } = useField<boolean>(() => 'travelInfo.withPackage');
  const { value: transportValue, errorMessage: transportErrorMessage } = useField<number | null>(() => 'transportation.id');
  const { value: transportOptionValue, errorMessage: transportOptionErrorMessage } = useField<number | null>(() => 'transportation.optionId');
  const { value: withoutTransportSelectionValue } = useField<boolean>(() => 'travelInfo.withoutTransport');
  const { value: specialCaseSelectionValue } = useField<boolean>(() => 'travelInfo.specialCase');
  const { setValue: setOutboundDate } = useField<Date | null>(() => 'transportation.outboundDate');
  const { setValue: setReturnDate } = useField<Date | null>(() => 'transportation.returnDate');
  const { setValue: setOutboundTransfer } = useField(() => 'transfer.outboundId');
  const { setValue: setReturnTransfer } = useField(() => 'transfer.returnId');
  const { setValue: setRoundTripTransfer } = useField(() => 'transfer.roundTripId');

  const hasTransports = computed(() => {
    return (participation.value?.travel.transportations?.length ?? 0) > 0;
  });

  const sortedOptions = (transport: UserTransportation) => {
    return transport.options?.slice().sort((a, b) => (a.rank??99) - (b.rank??99)) ?? [];
  };

  const canBeSelected = (option: UserTransportationOption) => {
    return option.quota == 0 || option.quotaLeft >= ((participation.value?.companions?.length ?? 0) +1) || (userStore.connectedUser?.isAdmin == true)
  }

  const resetTransfers = () => {
    setOutboundTransfer(null,false);
    setReturnTransfer(null,false);
    setRoundTripTransfer(null,false);
  };

  watch(() => participation.value?.travel.packageMandatory, (mandatory) => {
    if (mandatory) {
      packageSelectionValue.value = true;
    }
  }, { immediate: true });

  watch(packageSelectionValue, (newValue) => {
    if(!newValue)
    {
      transportValue.value = null;
      withoutTransportSelectionValue.value = false;
      specialCaseSelectionValue.value = false;
      setOutboundDate(null,false);
      setReturnDate(null,false);
    }

    resetTransfers();
  });

  watch(transportValue, (newValue) => {
    if (newValue)
    {
      withoutTransportSelectionValue.value = false;
      specialCaseSelectionValue.value = false;
    }
  });

  watch(withoutTransportSelectionValue, (newValue) => {
    if (newValue)
    {
      transportValue.value = null;
      specialCaseSelectionValue.value = false;
      setOutboundDate(participation.value?.travel?.startDate ?? null);
      setReturnDate(participation.value?.travel?.endDate ?? null);
    }

    resetTransfers();
  });

  watch(specialCaseSelectionValue, (newValue) => {
    if (newValue)
    {
      transportValue.value = null;
      withoutTransportSelectionValue.value = false;
      setOutboundDate(participation.value?.travel?.startDate ?? null);
      setReturnDate(participation.value?.travel?.endDate ?? null);
    }

    resetTransfers();
  });

</script>
